import React from "react";
import ThicknessClassListItem from "../../components/thicknessClass/ThicknessClassList/ThicknessClassListItem";
import {Box} from "@mui/material";
import {useParams} from "react-router";
import {useTitle} from 'react-use';
import { t } from "@lingui/core/macro";

const ThicknessClassListPage = ()  => {

    useTitle(t`List Thickness Class`);
    
    const allQueries = useParams()
    const query = Object.fromEntries(
        Object.entries(allQueries).filter(([key]) => key.endsWith("Id"))
    )
    
    return (
        <Box>
            <ThicknessClassListItem showAdd={true} {...query} />
        </Box>
    )
}

export default ThicknessClassListPage;
